import { styled } from '@mui/system';
import moment from 'moment';

export const SearchFilterList = [
  { label: 'Shipment No.', value: 'shipmentNumber' },
  { label: 'AWB No.', value: 'awbNumber' },
];

export const initialDateRange = {
  startDate: moment().subtract(1, 'months').startOf('day').toDate(),
  endDate: moment().endOf('day').toDate(),
};

export const ShipmentTypeList = [
  {
    value: 'import',
    display: 'Import',
  },
  {
    value: 'export',
    display: 'Export',
  },
  {
    value: 'domestic',
    display: 'Domestic',
  },
];

export const TableActionContainer = styled('div')(({ theme }) => ({
  margin: '2rem 0',
  display: 'grid',
  gridTemplateColumns: '380px 1fr  fit-content(150px)  fit-content(150px) 150px',
  columnGap: '15px',
  [theme.breakpoints.down('xl')]: {
    columnGap: '8px',
    gridTemplateColumns: '380px 1fr  fit-content(150px)  fit-content(150px) 120px',
  },
  [theme.breakpoints.down('lg')]: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1rem',
    div: {
      width: 'auto',
    },
  },
}));

export const splitTaxOptions = [
  {
    display: 'Split Tax',
    value: 'true',
  },
  {
    display: 'Full Tax',
    value: 'false',
  },
];

export const formatLabel = (value?: unknown): string => {
  if (typeof value !== 'string') return '';
  return value.replace(/_/g, ' ');
};

interface VendorLocation {
  name: string;
  locationId: string;
}

interface CarrierOption {
  value: string;
  display: string;
  d365AccountDisplayValue?: string;
  vendorLocationMap: VendorLocation[];
}

export const getCarrierDetails = (
  carrierOptions: CarrierOption[],
  selectedCarrierId: string,
): {
  d365AccountDisplayValue: string;
  vendorLocationMap: VendorLocation[];
} => {
  const matchedCarrier = carrierOptions.find(carrier => carrier.value === selectedCarrierId);

  return {
    d365AccountDisplayValue: matchedCarrier?.d365AccountDisplayValue || '',
    vendorLocationMap: matchedCarrier?.vendorLocationMap || [],
  };
};
